import React, { Component } from 'react';
import * as firebase from 'firebase';
import { PieChart, Pie, Sector, Cell } from 'recharts';
import _ from 'lodash';
import Header from './Header/Header';
import { Container, FormTitle as Title, SubTitle, ChartContainer } from './Styles/index';

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
    fill, payload, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>{payload.name}</text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`Orders: ${value}`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`(Rate ${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};
const COLORS = ['#4CAF50', '#673AB7', '#0088FE', '#FFBB28' ];

class Home extends Component {

  constructor(props) {
    super(props)
    this.state = {
      orders: [],
      activeOrders: [],
      ordersByStatus: [],
      activeIndex: 0,
      activeIndexStatus: 0
    }
  }
 

  onPieEnter = (data, index) => {
    this.setState({
      activeIndex: index,
    });
  }

  onPieEnter2 = (data, index) => {
    this.setState({
      activeIndexStatus: index,
    });
  }

  _selectColor(entry){
    switch (entry.name) {
      case 'pending':
        return '#ff3333'
      case 'awaiting-fullfilment':
        return '#183787'
      case 'partially-shipped':
        return '#FFBB28'
      case 'completed':
        return '#4CAF50';
      default:
        return '#0088FE'
    }
  }

  _processOrders(){
    return _.chain(this.state.orders)
            .groupBy("status").toPairs()
            .map(order => _.zipObject(['name', 'value'], [order[0], order[1].length]))
            .sortBy((order) => {
              return order.value
            }).reverse().value()
  }

  componentWillMount() {
    firebase.database().ref().child('cart_sessions').once('value', snapshot  => {
      snapshot.forEach(order => {
        if (order.val().active) {
          this.setState({
            activeOrders: [...this.state.activeOrders, order.val()] 
          });
        }
        else {
          this.setState({
            orders: [...this.state.orders, order.val()] 
          }, () => {
            this.setState({
              ordersByStatus:  this._processOrders(),
            });
          });
        }
      })
    })
  }

  render() {
    return (
      <div>
        <Header/>
        <Container style={{padding: '32px 0'}}>
          <Title>Dashboard</Title>
        </Container>
        <div style={{maxWidth: '1440px', margin: '0 auto', display: 'flex', justifyContent: 'center', overflowX: 'auto', overflowY: 'hidden'}}>
          <ChartContainer>
            <PieChart width={700} height={500}>
              <Pie
                dataKey="value" 
                activeIndex={this.state.activeIndex}
                activeShape={renderActiveShape} 
                onMouseEnter={this.onPieEnter}
                data={[
                  {
                    name: 'Active Orders',
                    value: this.state.activeOrders.length
                  },
                  {
                    name: 'Orders',
                    value: this.state.orders.length
                  }
                ]} 
                cx={350} 
                cy={250} 
                innerRadius={120}
                outerRadius={180} 
                fill="#8884d8">
                  {[
                  {
                    name: 'Active Orders',
                    value: this.state.activeOrders.length
                  },
                  {
                    name: 'Orders',
                    value: this.state.orders.length
                  }
                ].map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]}/>)}
                </Pie>
            </PieChart>
            <SubTitle center>Total Orders</SubTitle>
          </ChartContainer>
          <ChartContainer divider>
            <PieChart width={700} height={500}>
              <Pie
                dataKey="value" 
                activeIndex={this.state.activeIndexStatus}
                activeShape={renderActiveShape} 
                onMouseEnter={this.onPieEnter2}
                data={this.state.ordersByStatus} 
                cx={350} 
                cy={250} 
                innerRadius={120}
                outerRadius={180} 
                fill="#8884d8">
                  {this.state.ordersByStatus.map((entry, index) => <Cell key={index} fill={this._selectColor(entry)}/>)}
                </Pie>
            </PieChart>
             <SubTitle center>Orders in process</SubTitle>
          </ChartContainer>
         
        </div>
        
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js